<template>
  <a-button type="default" @click="insertTemplate" :loading="isInserting">
    <a-icon type="import" /> Nhập word template
  </a-button>
</template>
<script>
import OXmlContent from "./templateXml.js";
import { updateContentControl } from "./contentControl.service";

const listControl = ["ict_eform_nguoi", "ict_eform_donvi", "ict_eform_ngay"];
export default {
  data() {
    return {
      isInserting: false
    };
  },
  computed: {
    currentUser() {
      return this.$store.state.auth;
    }
  },
  methods: {
    async insertTemplate() {
      // Xem thêm
      // https://docs.microsoft.com/en-us/javascript/api/word/word.body?view=word-js-1.3.

      this.isInserting = true;
      const { currentUser } = this;
      try {
        // B1: Chèn nội dung từ open XML
        await Word.run(async context => {
          // Create a proxy object for the document body.
          const body = context.document.body;

          body.insertOoxml(OXmlContent, Word.InsertLocation.replace);

          // Synchronize the document state by executing the queued commands,
          // and return a promise to indicate task completion.
          await context.sync();
        });
        console.log("đã import xong nội dung");

        // B2: Thay thế nội dung content control
        await Promise.all(
          await listControl.map(async e => {
            console.log("Start ", e);
            //currentUser
            const noiDung = {
              ict_eform_nguoi: currentUser.fullname || currentUser.username,
              ict_eform_ngay: new Date().toLocaleDateString()
            };
            if (currentUser.department && currentUser.department.name) {
              noiDung["ict_eform_donvi"] = currentUser.department.name;
            }
            console.log("End ", e);
            return updateContentControl(e, noiDung[e]);
            // return new Promise.resolve(true);
          })
        );
        console.log("done");

        this.isInserting = false;
      } catch (error) {
        console.log(error);
        this.isInserting = false;
      }
    }
  }
};
</script>
